module.exports = __webpack_public_path__ + "img/media_7.48cc05ad.jpg";